module.exports = __webpack_public_path__ + "static/media/viktorrolfspicebomb.2f21b242.png";